<template>
  <BButton
    class="app-button"
    :class="classes"
    v-on="$listeners"
    :block="block"
    :disabled="disabled"
    :to="to"
    :href="href"
    :size="size"
    :variant="variant"
  >
    <slot />
  </BButton>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component
export default class AppButton extends Vue {
  @Prop({
    default: false,
    type: Boolean
  })
  block!: boolean;

  @Prop({
    required: false,
    default: false,
    type: Boolean
  })
  disabled!: boolean;

  @Prop({
    required: false,
    default: "md",
    type: String
  })
  size!: "sm" | "md";

  @Prop({
    required: false,
    default: null,
    type: Object
  })
  to!: object | null;

  @Prop({
    required: false,
    default: "",
    type: String
  })
  href!: string;

  @Prop({
    required: false,
    default: "primary",
    type: String
  })
  variant!: string;

  @Prop({
    required: false,
    default: false,
    type: Boolean
  })
  rounded!: boolean;

  get classes() {
    const ar = [`app-button--${this.size}`];
    if (this.rounded) {
      ar.push("rounded");
    }
    return ar.join(" ");
  }
}
</script>

<style lang="scss">
.app-button {
  font-weight: 500;

  &--sm {
    font-size: 14px;
    border-radius: 8px;
  }

  &--md {
    padding-top: 11px;
    padding-bottom: 11px;
    border-radius: 8px;
  }

  &.disabled,
  &:disabled {
    color: $gray-05;
    background-color: $gray-03;
    border-color: $gray-03;
    opacity: 1;

    & > p,
    span {
      color: $gray-05;
    }
  }
}

.rounded {
  border-radius: 9999px !important;
}
</style>
